import Html from "./Html";
import { Provider } from "./Provider";

const RejectedApplications = () => {
    return (
        <Provider>
            <Html />
        </Provider>
    )
}

export default RejectedApplications;